import { createSlice } from '@reduxjs/toolkit'

export const allDRGInProjectSlice = createSlice({
    name: 'allDRGInProject',
    initialState: {
        result: [],
    },
    reducers: {
        setAllDRGInProject: (state, action) => {
            state.result = action.payload;
        },
        clearAllDRGInProject: (state) => {
            state.result = [];
        }
    },
})

export const { setAllDRGInProject, clearAllDRGInProject } = allDRGInProjectSlice.actions;

export const getAllDRGInProject = (state) => state.allDRGInProject.result;

export default allDRGInProjectSlice.reducer